import $ from 'cash-dom'

// $(document).on('load', () => {
//   $('.faq-item').not('.is-open').addClass('is-closed')
// })

$(document).on('click', '.bof-prices-list-link.is-centered.is-mobile', (e) => {
  e.preventDefault()
  console.log(e);
  const item = $(e.currentTarget.nextElementSibling)
  const icon = $(e.currentTarget.children[0])
  item.toggleClass('is-open')
  icon.toggleClass('fa-chevron-down')
  icon.toggleClass('fa-chevron-up')
})

$(document).on('click', '.bof-plans-toggle', (e) => {
  e.preventDefault()
  console.log(e);
  const item = $(e.currentTarget)
  $('.bof-plans-toggle').removeClass('is-active')
  const isAddons = item.hasClass('is-addons')

  if (isAddons) {
    $('.bof-pricelist-addons.is-addons').removeClass('is-hidden')
    $('.bof-prices-items.is-plans').addClass('is-hidden')
  } else {
    $('.bof-prices-items.is-plans').removeClass('is-hidden')
    $('.bof-pricelist-addons.is-addons').addClass('is-hidden')
  }
  item.addClass('is-active')
})

$(document).on('click', '.bof-prices-toggle', (e) => {
  e.preventDefault()
  const item = $(e.currentTarget)
  $('.bof-prices-toggle').removeClass('is-active')
  const isMonthly = $('.bof-prices-toggle.is-monthly').hasClass('is-active')

  if (item.hasClass('is-yearly')) {
    $('.bof-prices-toggle.is-yearly').addClass('is-active')
    $('.bof-prices-item-header-title span.is-monthly').addClass('is-hidden')
    $('.bof-prices-item-header-title span.is-yearly').removeClass('is-hidden')
  } else {
    $('.bof-prices-toggle.is-monthly').addClass('is-active')
    $('.bof-prices-item-header-title span.is-monthly').removeClass('is-hidden')
    $('.bof-prices-item-header-title span.is-yearly').addClass('is-hidden')
  }
})